import { IStoreProps } from '../../Global/Store';
import { IAcquireTestResultsBody } from 'appwiki-link-shield-proxy';

export const getLocation = ({ historyListener }: IStoreProps) =>
  historyListener.location;

export const areActiveTestsCompleted = ({ features }: IStoreProps) =>
  features.loadingBar.testsCompleted;

export const getRedirectUrl = ({ features }: IStoreProps) =>
  features.loadingBar.redirectUrl;

export const getLinkShieldSession = ({ features }: IStoreProps) =>
  features.loadingBar.linkShieldSession;

export const getProviderResults = ({
  features,
}: IStoreProps): IAcquireTestResultsBody[] =>
  features.loadingBar.providerResults;
